import { NavItem, NavItemResources, NavItemServices } from './components';
import React, { useEffect, useState } from 'react';
import { alpha, useTheme } from '@mui/material/styles';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import {Link} from 'react-router-dom';
import MenuIcon from '@mui/icons-material/Menu';
import PropTypes from 'prop-types';
import { SimTypography } from 'components/SimTypography';
import simsoulsLogoColor from 'assets/images/simsoulsLogoColor.png';

// AUTISM WORKING //

const TopBar = ({ onSidebarOpen, pages, colorInvert = true }) => {
	const theme = useTheme();

	const { linkTreeFLAT: linkTreeFLATPages } = pages;

	const serviceNavListStatic = [
		{
			label: 'ESSENTIALS',
			body: [
				{
					hasLink: 1,
					hasTabs: 0,
					isTabLink: 1,
					showSections: true,
					title: 'Screening',
					href: '/services#ANCHOR_Services_Essentials',
					sections: [
						{
							sectionTitle: 'Autism',
							sectionAnchorLink: '/services/diagnostics#ANCHOR_Diagnostics_Autism'
						},
						{
							sectionTitle: 'Functional Behavior',
							sectionAnchorLink: '/services/diagnostics#ANCHOR_Diagnostics_FuncBehavior'
						},
						{
							sectionTitle: 'Skill Deficit',
							sectionAnchorLink: '/services/diagnostics#ANCHOR_Diagnostics_SkillDef'
						}
					]
				},
				{
					hasLink: 1,
					hasTabs: 0,
					isTabLink: 1,
					showSections: true,
					title: 'Therapies',
					href: '/services#ANCHOR_Services_Essentials',
					sections: [
						{
							sectionTitle: 'ABA Therapy',
							sectionAnchorLink: '/services/therapy#ANCHOR_Therapy_ABATherapy'
						},
						{
							sectionTitle: 'Couples Therapy',
							sectionAnchorLink: '/resources'
						},
						{
							sectionTitle: 'Occupational/Feeding Therapy',
							sectionAnchorLink: '/services/therapy#ANCHOR_Therapy_FeedingTherapy'
						},
						{
							sectionTitle: 'Speech/Language Therapy',
							sectionAnchorLink: '/services/therapy#ANCHOR_Therapy_SpeechTherapy'
						}
					]
				}
			]
		},

		{
			label: 'CARES',
			body: [
				{
					hasLink: 1,
					hasTabs: 0,
					isTabLink: 1,
					showSections: true,
					title: 'ParentEd',
					href: '/services#ANCHOR_Services_Cares',
					sections: [
						{
							sectionTitle: 'Ask an Expert',
							sectionAnchorLink: '/services/parents#ANCHOR_ParentServices_Community'
						},
						{
							sectionTitle: 'Community Training',
							sectionAnchorLink: '/services/parents#ANCHOR_ParentServices_ParentEd'
						},
						{
							sectionTitle: 'Community Workshops',
							sectionAnchorLink: '/services/parents#ANCHOR_ParentServices_Community'
						},
						{
							sectionTitle: 'Online Training',
							sectionAnchorLink: '/services/parents#ANCHOR_ParentServices_Community'
						}
					]
				},
				{
					hasLink: 1,
					hasTabs: 0,
					isTabLink: 1,
					showSections: true,
					title: 'Parent Support',
					href: '/services#ANCHOR_Services_Cares',
					sections: [
						{
							sectionTitle: 'Coach',
							sectionAnchorLink: '/services/parents#ANCHOR_ParentServices_Coach'
						},
						{
							sectionTitle: 'Join Community',
							sectionAnchorLink: '/services/parents#ANCHOR_ParentServices_Nanny'
						},
						{
							sectionTitle: 'Nanny',
							sectionAnchorLink: '/services/parents#ANCHOR_ParentServices_Nanny'
						}
					]
				}
			]
		}
	];

	const resourceNavListStatic = [
		{
			label: 'none',
			body: [
				{
					hasLink: 1,
					hasTabs: 0,
					isTabLink: 0,
					showSections: false,
					title: 'Cope with a Special Child',
					href: '/resources/cope-with-special-child'
				},
				{
					hasLink: 1,
					hasTabs: 0,
					isTabLink: 0,
					showSections: false,
					title: 'Child Development',
					href: '/resources/child-development'
				},
				{
					hasLink: 0,
					hasTabs: 0,
					isTabLink: 0,
					showSections: true,
					title: 'Developmental Disorders',
					href: '',
					sections: [
						{
							sectionTitle: 'Autism',
							sectionAnchorLink: '/resources'
						},
						{
							sectionTitle: 'ADHD',
							sectionAnchorLink: '/resources'
						},
						{
							sectionTitle: "Asperger's Syndrome",
							sectionAnchorLink: '/resources'
						},
						{
							sectionTitle: 'Speech & Language Disorders',
							sectionAnchorLink: '/resources'
						},
						{
							sectionTitle: 'Echolalia',
							sectionAnchorLink: '/resources'
						},
						{
							sectionTitle: 'Intellectual Developmental Disorder',
							sectionAnchorLink: '/resources'
						},
						{
							sectionTitle: 'Global Developmental Delay',
							sectionAnchorLink: '/resources'
						},
						{
							sectionTitle: 'CDD',
							sectionAnchorLink: '/resources'
						},
						{
							sectionTitle: 'RETT Syndrome',
							sectionAnchorLink: '/resources'
						},
						{
							sectionTitle: 'Learning Disability',
							sectionAnchorLink: '/resources'
						},
						{
							sectionTitle: 'Celebral Palsy',
							sectionAnchorLink: '/resources'
						},
						{
							sectionTitle: 'Down Syndrome',
							sectionAnchorLink: '/resources'
						},
						{
							sectionTitle: 'Fragile X Syndrome',
							sectionAnchorLink: '/resources'
						},
						{
							sectionTitle: 'Prader Willi Syndrome',
							sectionAnchorLink: '/resources'
						},
						{
							sectionTitle: 'Deafblindness',
							sectionAnchorLink: '/resources'
						}
					]
				},
				{
					hasLink: 0,
					hasTabs: 0,
					isTabLink: 0,
					showSections: true,
					title: 'ParentEd programs',
					href: '',
					sections: [
						{
							sectionTitle: 'Child Development Program',
							sectionAnchorLink: '/resources'
						},
						{
							sectionTitle: 'ABA Therapy Program',
							sectionAnchorLink: '/resources'
						}
					]
				},
				{
					hasLink: 0,
					hasTabs: 0,
					isTabLink: 0,
					showSections: true,
					title: 'Screening',
					href: '',
					sections: [
						{
							sectionTitle: 'Autism Screening',
							sectionAnchorLink: '/resources'
						},
						{
							sectionTitle: 'Functional Behavior Screening',
							sectionAnchorLink: '/resources'
						},
						{
							sectionTitle: 'Skill Deficit Screening',
							sectionAnchorLink: '/resources'
						}
					]
				},
				{
					hasLink: 0,
					hasTabs: 0,
					isTabLink: 0,
					showSections: true,
					title: 'Therapies',
					href: '',
					sections: [
						{
							sectionTitle: 'ABA Therapy',
							sectionAnchorLink: '/resources'
						},
						{
							sectionTitle: 'Speech Therapy',
							sectionAnchorLink: '/resources'
						},
						{
							sectionTitle: 'Feeding Therapy',
							sectionAnchorLink: '/resources'
						},
						{
							sectionTitle: 'Occupational Therapy',
							sectionAnchorLink: '/resources'
						},
						{
							sectionTitle: 'Couples Therapy',
							sectionAnchorLink: '/resources'
						}
					]
				}
			]
		}
	];

	const [activeLink, setActiveLink] = useState('');
	useEffect(() => {
		setActiveLink(window && window.location ? window.location.pathname : '');
	}, []);

	const linkColor = colorInvert ? theme.palette.text.headerLight : 'common.white';

	return (
		<Box
			display={'flex'}
			justifyContent={'space-between'}
			alignItems={'center'}
			width={1}
			margin={0}
			bgcolor={theme.palette.primary.main}>
			<Box display={'flex'} component='a' href='/' title='Sim Souls' width={{ xs: 150, md: 180 }}>
				<Box component={'img'} src={simsoulsLogoColor} height={1} width={1} />
			</Box>

			<Box sx={{ display: { xs: 'none', md: 'flex' } }} alignItems={'center'}>
				<Box marginLeft={1} marginRight={1}>
					<NavItemServices
						title={'Services'}
						id={'services-pages'}
						items={serviceNavListStatic}
						colorInvert={colorInvert}
					/>
				</Box>

				<Box marginLeft={1} marginRight={1}>
					<NavItemResources
						title={'Resources'}
						id={'resource-pages-2'}
						items={resourceNavListStatic}
						colorInvert={colorInvert}
					/>
				</Box>

				<Box marginLeft={1} marginRight={1}>
					<Button
						component={'a'}
						href='/contact'
						fullWidth
						sx={{
							justifyContent: 'flex-start',
							color: activeLink === '/contact' ? theme.palette.primary.main : theme.palette.text.primary,
							backgroundColor:
								activeLink === '/Contact Us' ? alpha(theme.palette.primary.main, 0.1) : 'transparent',
							fontWeight: activeLink === '/contact' ? 600 : 400
						}}>
						<SimTypography
							fontWeight={activeLink === '/contact' ? 700 : 400}
							variant='menuRootText'
							color={linkColor}>
							Contact Us
						</SimTypography>
					</Button>
				</Box>

				<Box marginLeft={1} marginRight={1}>
					<Button
						component={'a'}
						href='/careers'
						fullWidth
						sx={{
							justifyContent: 'flex-start',
							color: activeLink === '/careers' ? theme.palette.primary.main : theme.palette.text.primary,
							backgroundColor:
								activeLink === '/careers' ? alpha(theme.palette.primary.main, 0.1) : 'transparent',
							fontWeight: activeLink === '/careers' ? 600 : 400
						}}>
						<SimTypography
							fontWeight={activeLink === '/careers' ? 700 : 400}
							variant='menuRootText'
							color={linkColor}>
							Careers
						</SimTypography>
					</Button>
				</Box>

				<Box marginLeft={1} marginRight={1}>
					<Button
						component={'a'}
						href='/about'
						fullWidth
						sx={{
							justifyContent: 'flex-start',
							color: activeLink === '/about' ? theme.palette.primary.main : theme.palette.text.primary,
							backgroundColor:
								activeLink === '/about' ? alpha(theme.palette.primary.main, 0.1) : 'transparent',
							fontWeight: activeLink === '/about' ? 600 : 400
						}}>
						<SimTypography
							fontWeight={activeLink === '/about' ? 700 : 400}
							variant='menuRootText'
							color={linkColor}>
							About Us
						</SimTypography>
					</Button>
				</Box>

				<Box marginLeft={1} marginRight={1}>
					<Button
						variant='contained'
						color='secondary'
						component={Link}
						to='auth/login'
						target='blank'
						size='large'
						sx={{ borderRadius: '40px', backgroundColor: 'white', paddingY: '3px' }}>
						<SimTypography variant='menuRootText' sx={{ color: theme.palette.text.btnSecondaryCTA }}>
							Login
						</SimTypography>
					</Button>
				</Box>

				<Box marginLeft={1} marginRight={1} display={'none'}>
					<NavItem
						title={'Pages'}
						id={'linkTreeFLAT-pages'}
						items={linkTreeFLATPages}
						colorInvert={colorInvert}
					/>
				</Box>
			</Box>

			<Box sx={{ display: { xs: 'block', md: 'none' } }} alignItems={'center'}>
				<Button
					onClick={() => onSidebarOpen()}
					aria-label='Menu'
					variant={'outlined'}
					sx={{
						borderRadius: 2,
						minWidth: 'auto',
						padding: 1,
						borderColor: alpha(theme.palette.primary.main, 0.1)
					}}>
					<MenuIcon sx={{ color: 'white' }} fontSize='large' />
				</Button>
			</Box>
		</Box>
	);
};

TopBar.propTypes = {
	onSidebarOpen: PropTypes.func,
	pages: PropTypes.object,
	colorInvert: PropTypes.bool
};

export default TopBar;
